<template>
      <NavBar />
      <HelloWorld/>
      <about/>
      <projectSection/>
      <PricingPlans/>
      <team/>
      <footerComp/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import NavBar from '@/components/NavBar.vue';
import PricingPlans from '@/components/PricingPlans.vue';
import projectSection from '@/components/projectSection.vue';
import footerComp from '@/components/footerComp.vue';
import about from '@/components/About.vue'
import team from '@/components/team.vue'
export default defineComponent({
  name: 'HomeView',
  components: {
    HelloWorld,
    NavBar,
    about,
    PricingPlans,
    projectSection,
    team,
    footerComp
  },
});
</script>
